import axios from "axios";
import {auth_token, URL} from '../utils/appParams'
import { removeUser } from "../utils/authService";


const apiPG = axios.create({
  baseURL: "https://coewarri.pythonanywhere.com",
  headers: {
    Accept: "application/json"
  },
});

apiPG.interceptors.request.use(
	config => {
		if (auth_token()) {
			config.headers['Authorization'] = `Bearer ${auth_token()}`
		}

		return config
	},
	error => Promise.reject(error)
);

apiPG.interceptors.response.use(
	(response) => response,
	(error) => {
	  if (error.response.status === 401) {
		logOut()
	  }
	  return Promise.reject(error);
	}
  );

  const logOut = () => {
    removeUser();
  };

export default apiPG;